import fastDeepEqual from 'fast-deep-equal';

export function getChangedKeys<T extends object>(obj1: T, obj2: T): (keyof T)[] {
    const changedKeys: (keyof T)[] = [];

    // Iterate over the keys of the first object
    Object.keys(obj1).forEach((key) => {
        const keyOfT = key as keyof T;

        // Check if the key exists in the second object and the value has changed
        if (obj2.hasOwnProperty(keyOfT) && !fastDeepEqual(obj1[keyOfT], obj2[keyOfT])) {
            changedKeys.push(keyOfT);
        }
    });

    return changedKeys;
}
